// extracted by mini-css-extract-plugin
export var addButton = "_pc-0";
export var border = "_pc-8";
export var check = "_pc-h";
export var danger = "_pc-6";
export var dropdownContainer = "_pc-1";
export var editModalBody = "_pc-j";
export var footerContainer = "_pc-i";
export var fullWidth = "_pc-a";
export var hide = "_pc-9";
export var icon = "_pc-3";
export var input = "_pc-7";
export var inputFlex = "_pc-b";
export var inputWrapper = "_pc-c";
export var manualFocus = "_pc-5";
export var optionButton = "_pc-4";
export var pillWrapper = "_pc-e";
export var pointer = "_pc-2";
export var showOverflow = "_pc-f";
export var tagsFlex = "_pc-d";
export var xButton = "_pc-g";